import { createContext } from 'react';

export const MeetingNumbers = createContext({});
